<div class="service-update-dialog">
    <button mat-icon-button type="button" class="close-dialog-button" (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
    </button>
    <span class="dialog-title">
        Actualización de servicios
    </span>
    <span class="dialog-description">
        El servicio fue actualizado correctamente, seleccione las oficinas que desea actualizar a los nuevos valores de pricing, porcentaje, tope máximo, tope mínimo, descuento contado, descuento financiado.
    </span>
    <div class="dialog-content">
        <app-data-table
            [rows]="offices"
            [columns]="columns"
            selectionType="multiple"
            [(selected)]="selectedOffices"
            [rowId]="rowId"
            [stickyHeader]="true"
            stickyHeaderBackground="white"
            maxHeight="450px"
            *ngIf="offices"
        ></app-data-table>
    </div>
    <div class="buttons">
        <button mat-raised-button color="accent" class="garantor-button" [disabled]="!selectedOffices.length" (click)="saveChanges()">Aplicar cambios</button>
    </div>
</div>
